var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile-item-details-modal-component"},[_c('div',{staticClass:"profile-item-details-modal-component__mask",on:{"click":function($event){return _vm.$emit('dismiss')}}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }